<template>
  <div class="notice" style="height: 0px;">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          <template v-if="!data.notice.id">
            新增
          </template>
          <template v-else>
            编辑
          </template>
          平台信息
        </el-text>
        <el-button-group>
          <el-button @click="router.go(-1)">返回</el-button>
          <el-button type="primary" @click="save()" :loading="loading.save">保存</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="系统编号">
        <el-input v-model="data.notice.kkey" />
      </el-form-item>
      <el-form-item label="Logo（60*216）">
        <el-upload list-type="picture-card" style="width: 100%;" v-model:file-list="data.file.file" :limit="1" :action="api.baseURL() + '/backend/file/upload'" :headers="api.tokenHeader()" multiple
          :on-error="() => ElMessage.error('上传失败')" :on-preview="(f) => util.previewElfile(f)" accept=".png,.jpg,.jpeg">
          <el-icon>
            <Plus />
          </el-icon>
        </el-upload>
      </el-form-item>
      <el-form-item label="平台名称">
        <el-input v-model="data.notice.title" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="data.notice.content" />
      </el-form-item>
    </el-form>
    <div style="height: 10px;"></div>
  </div>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import Editor from '../../components/Editor.vue'

const router = useRouter()
const loading = reactive({
  save: false,
})

const pageParam = cache.getObject(cache.keys.pageParam + "system")
const data = reactive({
  notice: pageParam ? JSON.parse(JSON.stringify(pageParam)) : { kkey: '' + Math.floor(Math.random() * 1000000000000000), sort: 0 },
  file: { file: [] },
})
if (data.notice.file) {
  data.file.file = util.json2Elfile(data.notice.file)
}

const save = () => {
  if (!data.notice.kkey) {
    ElMessage.error('保存失败')
    router.go(-1)
  }
  loading.save = true
  const notice = {
    type: 'SYSTEM',
    kkey: data.notice.kkey || '',
    hasShow: true,
    title: data.notice.title,
    content: data.notice.content || '',
    sort: data.notice.sort || 0,
    file: util.elfile2Json(data.file.file)
  }
  notice.file = util.elfile2Json(data.file.file)
  if (!data.notice.id) {
    api.post('/backend/notice/addNotice', notice).then(() => {
      ElMessage.success('保存成功')
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  } else {
    notice.createDatetime = null
    notice.id = data.notice.id
    api.post('/backend/notice/setNotice', notice).then(() => {
      ElMessage.success('保存成功')
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  }
}
</script>

<style lang="less">
.notice {
  margin: auto;
  max-width: 900px;

  .avatar-uploaded {
    width: 178px;
    height: 178px;
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    margin-right: 20px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
  }

  .avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
  }

  .el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
  }
}
</style>